import { render } from "./Button.vue?vue&type=template&id=161717ee"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=161717ee&lang=scss"

import exportComponent from "/Users/Max/Documents/Projekte/slf-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__